import type { ChatboxMode } from "@/hooks/useChatboxes";

/** UI preset for chatbox access (maps to `mode` + `allowGuestAccess`). */
export type ChatboxAccessPreset =
  | "project"
  | "invited_only"
  | "link_guests";

export function chatboxAccessPresetFromSettings(
  mode: ChatboxMode,
  allowGuestAccess: boolean,
): ChatboxAccessPreset {
  if (mode === "invited_only") {
    return "invited_only";
  }
  if (mode === "project_members") {
    return "project";
  }
  return allowGuestAccess ? "link_guests" : "project";
}

export function settingsFromChatboxAccessPreset(
  preset: ChatboxAccessPreset,
): { mode: ChatboxMode; allowGuestAccess: boolean } {
  switch (preset) {
    case "project":
      return { mode: "project_members", allowGuestAccess: false };
    case "link_guests":
      return { mode: "anyone_with_link", allowGuestAccess: true };
    case "invited_only":
      return { mode: "invited_only", allowGuestAccess: false };
  }
}
